module.exports = __webpack_public_path__ + "static/media/20180327_verantwoording.a7202ac0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20180327_verantwoording.pdf
// module id = 650
// module chunks = 0